import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import SingleViewPageTabs from '../../elements/ViewPageTabs';
import { dashboardTabs } from '../../project-dashboard/test-case/testCaseTableHead';
import TestCaseContent from './TestCaseContent';
import TestCycleContent from './TestCycleContent';
import IssueComponent from './IssueComponent';
import { useQuery } from '../../../lib/utils';
import AssignedTestCase from './AssignedTestCase';
import TestcaseForReview from './TestcaseForReview';

const LatestData = ({ projects }) => {
  const query = useQuery();
  const searchTerm = query.get('type');
  const [activeTab, setActiveTab] = useState(searchTerm || 'testcase');
  const navigate = useNavigate();
  const location = useLocation();
  const handleTabSelect = (tab) => {
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('type', tab);
    navigate(`${location.pathname}${currentUrl.search}`);
    setActiveTab(tab);
  };

  return (
    <Row className="mt-2">
      <Col>
        <SingleViewPageTabs
          activeTab={activeTab}
          onTabSelect={handleTabSelect}
          tabHeaders={dashboardTabs}
        />
        {activeTab === 'testcase' && <TestCaseContent projects={projects} />}
        {activeTab === 'testcycle' && <TestCycleContent projects={projects} />}
        {activeTab === 'issue' && <IssueComponent projects={projects} />}
        {activeTab === 'assignedForExecution' && <AssignedTestCase projects={projects} />}
        {activeTab === 'assignedForReview' && <TestcaseForReview projects={projects} />}
      </Col>
    </Row>
  );
};

export default LatestData;
